// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-Subheading-control-SubheadingComparisonRow-module__cell webpack-concepts-Extraction-Compare-ComparisonTable-ComparisonTable-module__labelCell webpack-concepts-Extraction-Compare-ComparisonTable-ComparisonTable-module__paddedCell";
export { _1 as "cell" }
